// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/views/home/Index.vue'),
        },
        {
          path: 'products',
          name: 'Products',
          component: () => import('@/views/products/Index.vue'),
        },
        {
          path: 'vision',
          name: 'Vision',
          component: () => import('@/views/vision/Index.vue'),
        },
        {
          path: 'contact-us',
          name: 'Contact',
          component: () => import('@/views/contact-us/Index.vue'),
        },
        {
          path: 'privacy-policy',
          name: 'Privacy Policy',
          component: () => import('@/views/legal/PrivacyPolicy.vue'),
        },
        {
          path: 'terms-of-service',
          name: 'Terms of Service',
          component: () => import('@/views/legal/TermsOfService.vue'),
        },
        {
          path: 'data-deletion',
          name: 'Data Deletion',
          component: () => import('@/views/legal/DataDeletion.vue'),
        },
        {
          path: 'privacy-policy/totalchaos',
          name: 'Total Chaos Privacy Policy',
          component: () => import('@/views/legal/TotalChaosPrivacy.vue'),
        },
        {
          path: 'support/totalchaos',
          name: 'Total Chaos Support',
          component: () => import('@/views/legal/TotalChaosSupport.vue'),
        },
        {
          path: 'privacy-policy/devprompt',
          name: 'Devprompt Privacy Policy',
          component: () => import('@/views/legal/DevpromptPrivacy.vue'),
        },
        {
          path: 'support/devprompt',
          name: 'Devprompt Support',
          component: () => import('@/views/legal/DevpromptSupport.vue'),
        },
        {
          path: 'privacy-policy/dadjokes',
          name: 'Dad Jokes Vault Privacy Policy',
          component: () => import('@/views/legal/DadjokesPrivacy.vue'),
        },
        {
          path: 'support/dadjokes',
          name: 'Dad Jokes Vault Support',
          component: () => import('@/views/legal/DadjokesSupport.vue'),
        },
        {
          path: 'privacy-policy/tiozao',
          name: 'Tiozão Privacy Policy',
          component: () => import('@/views/legal/TiozaoPrivacy.vue'),
        },
        {
          path: 'support/tiozao',
          name: 'Tiozão Support',
          component: () => import('@/views/legal/TiozaoSupport.vue'),
        },
        // Legacy PartyPulse URLs still referenced from the App Store listing.
        { path: 'privacy-policy/partypulse', redirect: '/privacy-policy/totalchaos' },
        { path: 'support/partypulse', redirect: '/support/totalchaos' },
        {
          path: '*',
          name: 'FourOhFour',
          component: () => import('@/views/404/Index.vue'),
        },
      ],
    },

  ],
})

export default router
